import React from "react";

// context
import { useInlineTextEdit } from "core/InlineTextEdit/index.js";

// components
import {
    FormControlGroup,
    TextArea as CoreTextArea
} from "frontend/components/core/FormControls";
import TextEdit from "../TextEdit";

export const TextArea = ({ ...rest }) => {
    const {
        inputRef,
        id,
        editedText,
        ariaLabel,
        placeholder,
        onInputChange,
        onInputBlur,
        errorMessage
    } = useInlineTextEdit();

    const sharedProps = {
        controlId: id,
        ariaLabel: ariaLabel,
        errorMessage: errorMessage
    };

    return (
        <TextEdit>
            <FormControlGroup hideLabel={true} {...sharedProps}>
                <CoreTextArea
                    inputRef={inputRef}
                    onChange={onInputChange}
                    onBlur={onInputBlur}
                    value={editedText}
                    placeholder={placeholder}
                    minLength="3"
                    maxLength="255"
                    {...sharedProps}
                    {...rest}
                />
            </FormControlGroup>
        </TextEdit>
    );
};

export default TextArea;
